define('models/config/VoicemailPolicy',[
    'lib/knockout',
    'util/ObservableModel'
], function (ko, ObservableModel) {
    'use strict';

    var VoicemailPolicy = ObservableModel.extend({
        defaults: {
            enabled: false,
            retentionTimeDays: "",
            alertTimeoutSeconds: "",
            minimumRecordingTimeSeconds: "",
            maximumRecordingTimeSeconds: "",
            quotaSizeBytes: ""
        }
    }, function () {});

    return VoicemailPolicy;
});
